const breakpoints = ['460px', '760px', '1200px']

export const theme = {
  fonts: {
    familySansSerif: "'LatoRegular', 'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
    familyLatoHeavy: "'LatoHeavy', 'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
    familyLatoBold: "'LatoBold', 'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
    familyLatoSemibold: "'LatoSemibold', 'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
    familyLatoMedium: "'LatoMedium', 'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
    familyLatoRegular: "'LatoRegular', 'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
  },
  colors: {
    darkBlue: '#394352',
    blue: '#0E76EB',
    lightGray: '#F3F5F7',
    bluePurple: '#29377b',
  },
  palette: {
    primary: '#070707',
    primaryDark: '#000000',
    primaryLight: '#131313',

    secondary: '#D6D6D6',
    secondaryDark: '#C4C4C4',
    secondaryLight: '#F2F2F2',

    accent: '#0064C4',
    accentDark: '#0052D6',
    accentLight: '#74B7FD',

    error: '#E41C1C',
    errorDark: '#FFA6A6',
    errorLight: '#FFE7E7',

    disabled: '#909090',
    disabledDark: '#595959',
    disabledLight: '#7C7C7C',

    background: '#FEFEFE',
    backgroundDark: '#202124',
    backgroundLight: '#F2F2F3',

    borders: '#E4E4E5',
    bordersDark: '#DCDCDC',
    bordersLight: '#EAEAEB',

    success: '#0A7A5A',
    successDark: '#064734',
    successLight: '#0ea57a',

    text: '#000000',
    textDark: '#393939',
    textLight: '#909090',
    textLighter: '#DCDCDC',
    textOnAccent: '#FFFFFF',
    textOnError: '#FFFFFF',
    textOnDisabled: '#FFFFFF',
    textOnPrimary: '#FFFFFF',
    textOnSecondary: '#202124',
    textOnSuccess: '#FFFFFF',

    white: '#FFFFFF',
    black: '#000000',

    inputBackground: '#F2F2F3',
    inputColor: '#070707',
    inputPlaceholderColor: '#909090',
  },
  typography: {
    fontFamily: 'Inter, sans-serif',

    textSize: 16,
    textSizeSmallest: 10,
    textSizeSmaller: 12,
    textSizeSmall: 14,
    textSizeLarge: 20,
    textSizeLarger: 28,
    textSizeLargest: 34,

    inputTextSize: 13,
  },
  shadows: {
    boxMain: '1px 1px 2px 1px rgba(0, 0, 0, 0.2)',
    boxThin: 'inset 0 -1px 0 0 #E4E4E5',
  },
  helpers: {
    gutter: '8px',
    gutterLarge: '16px',

    textareaRows: 5,

    zIndexLayout: 1,
    zIndexLayoutImage: -1,

    borderRadius: 6,
    borderRadiusSmall: 4,
    borderRadiusLarge: 8,

    inputCounterInputWidth: 50,
    inputCounterInputHeight: 30,
    inputCounterButtonSize: 26,

    radioboxSize: 22,
  },
  transition: {
    duration: 200,
    durationLong: 500,

    easing: 'ease-in-out',
  },
  breakpoints,
  mediaQueries: {
    small: `@media screen and (min-width: ${breakpoints[0]})`,
    medium: `@media screen and (min-width: ${breakpoints[1]})`,
    large: `@media screen and (min-width: ${breakpoints[2]})`,
  },
  // TODO: remove theme.typography sizes in favour of styled-system attempt below:
  fontSizes: [10, 12, 14, 16, 20, 28, 34],
  space: [0, 4, 8, 16, 24, 32, 48, 64],
  zIndices: [1, 10, 20, 30, 40, 50, 100, 1000],
}

export type Theme = typeof theme
export type ThemeProps = { theme: Theme }
